import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import s from '../../pages/PedidosOrcamentos.module.css';
import InputDataFiltro from '../common/InputDataFiltro';
import useNavegacaoLista from '../../hooks/useNavegacaoLista';

const fmtMoeda = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtData  = str => str ? new Date(str).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—';
const hojeISO  = () => new Date().toLocaleDateString('en-CA');

// Busca de venda pra origem de uma NF-e emitida manualmente (Módulo Fiscal →
// Nota Fiscal → Novo → "De uma Venda") — mesmo padrão visual do F7 do PDV,
// mas só seleção: sem botões de emitir/cancelar/reenviar documento fiscal,
// que não fazem sentido aqui (a venda ainda nem tem NF-e nenhuma emitida
// necessariamente, e mesmo que tenha, aqui é só a fonte dos dados pra outra).
export default function ModalSelecionarVenda({ onSelecionar, onClose }) {
  const [dataInicio, setDataInicio] = useState(hojeISO());
  const [dataFim, setDataFim]       = useState(hojeISO());
  const [busca, setBusca]           = useState('');
  const [lista, setLista]           = useState([]);
  const [buscando, setBuscando]     = useState(false);
  const [sel, setSel]               = useState(null);
  const inputRef = useRef(null);

  const buscar = async () => {
    setBuscando(true);
    try {
      const { data } = await api.get('/vendas', {
        params: {
          dataInicio: dataInicio || undefined,
          dataFim:    dataFim || undefined,
          cliente:    busca || undefined,
          codigo:     /^\d+$/.test(busca.trim()) ? busca.trim() : undefined,
          limite: 200,
        },
      });
      setLista(Array.isArray(data) ? data : []);
    } catch { setLista([]); }
    finally { setBuscando(false); }
  };

  useEffect(() => { buscar(); inputRef.current?.focus(); }, []); // eslint-disable-line

  // Enter no campo com linha marcada escolhe; digitar de novo desmarca e o Enter volta a buscar.
  const refLinha = useNavegacaoLista({
    lista, indice: lista.findIndex(v => v.id === sel?.id), aoMudar: setSel, aoEnter: onSelecionar,
  });

  return (
    <div className={s.overlay} data-enter-scope="off" onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className={s.modal} style={{ maxWidth: 860 }}>
        <div className={s.modalTitle}>🧾 Selecionar Venda — origem da NF-e</div>
        <div className={s.modalBody}>
          <div className={s.modalSearchRow} style={{ flexWrap: 'wrap', gap: 6 }}>
            <input ref={inputRef} className={s.inputErp} style={{ flex: 1, minWidth: 160 }}
              placeholder="Código ou nome do cliente..."
              value={busca} onChange={e => { setBusca(e.target.value); setSel(null); }}
              onKeyDown={e => e.key === 'Enter' && buscar()} />
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, whiteSpace: 'nowrap' }}>
              De:
              <InputDataFiltro className={s.inputErp} style={{ width: 130 }}
                value={dataInicio} onChange={e => setDataInicio(e.target.value)} />
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, whiteSpace: 'nowrap' }}>
              Até:
              <InputDataFiltro className={s.inputErp} style={{ width: 130 }}
                value={dataFim} onChange={e => setDataFim(e.target.value)} />
            </label>
            <button className={s.btnErp} onClick={buscar} disabled={buscando}>
              {buscando ? 'Buscando...' : 'Filtrar'}
            </button>
          </div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <table className={s.modalTabela}>
              <thead>
                <tr>
                  <th>#</th><th>Data</th><th>Cliente</th>
                  <th>Doc. Fiscal</th><th style={{ textAlign: 'right' }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {lista.length === 0 && !buscando && (
                  <tr><td colSpan={5} style={{ padding: 10, color: '#888', textAlign: 'center' }}>
                    Nenhuma venda encontrada no período.
                  </td></tr>
                )}
                {lista.map(v => (
                  <tr key={v.id} ref={sel?.id === v.id ? refLinha : null} className={sel?.id === v.id ? s.selRow : ''}
                    onClick={() => setSel(v)} onDoubleClick={() => onSelecionar(v)}>
                    <td style={{ fontWeight: 'bold' }}>{v.id}</td>
                    <td>{fmtData(v.data)}</td>
                    <td>{v.cliente || 'Consumidor Final'}</td>
                    <td>
                      {v.doc_fiscal_tipo ? v.doc_fiscal_tipo.toUpperCase() : '—'}
                      {(v.doc_fiscal_status === 'autorizada' || v.doc_fiscal_status === 'epec') && (
                        <span style={{ marginLeft: 4, fontSize: 10, color: '#b45309' }} title="Já tem documento ativo — não vai dar pra emitir outro sem cancelar antes">
                          ⚠
                        </span>
                      )}
                    </td>
                    <td style={{ textAlign: 'right' }}>{fmtMoeda(v.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className={s.modalFooter}>
          <button className={s.btnErp} onClick={() => sel && onSelecionar(sel)} disabled={!sel}>Selecionar</button>
          <button className={s.btnErp} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
